/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Chaitanya's Portfolio",
  description:
    "Hi! I am a junior at Georgetown University majoring in Computer Science with a focus on artificial intelligence and computer vision. My interests lie at the intersection of sports and machine learning to provide data-driven insights that can bolster team performance. I am also fascinated by the capabilities of large language models (LLMs) and making them more robust and secure. Feel free to reach out!",
  og: {
    title: "Chaitanya Prasad's Portfolio",
    type: "website",
    url: "http://chaitanyaprasad.com/",
  },
};

//Home Page
const greeting = {
  title: "Chaitanya Prasad",
  logo_name: "ChaitanyaPrasad",
  nickname: "Chai",
  subTitle:
    "Hi! I am a junior at Georgetown University majoring in Computer Science with a focus on artificial intelligence and computer vision. Feel free to reach out!",
  resumeLink:
    "https://drive.google.com/file/d/1ZbjR3Ask2bffz1FmdVdrZ8jUmLnzgwbR/view?usp=drive_link",
  portfolio_repository: "https://github.com/cp11203?tab=repositories",
  githubProfile: "https://github.com/cp11203?tab=repositories",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/cp11203?tab=repositories",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/chaitanya-p-42b7741b3/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:chaitanya11203@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  }
];

const skills = {
  data: [
    {
      title: "Data Science & AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
        "⚡ Experience of working with Computer Vision and NLP projects",
        "⚡ Complex quantitative modelling for dynamic forecasting and time series analysis",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Deeplearning",
          imageSrc: "deeplearning_ai_logo.png",
        },
      ],
    },
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive website front end using React-Redux",
        "⚡ Developing mobile applications using Flutter, React Native and solo android apps using Kotlin",
        "⚡ Creating application backend in Node, Express & Flask",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
        "⚡ Deploying deep learning models on cloud to use on mobile devices",
        "⚡ Setting up streaming jobs from DB to Server or vice-versa on GCP and AWS",
      ],
      softwareSkills: [
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
      ],
    },
    {
      title: "UI/UX Design",
      fileName: "DesignImg",
      skills: [
        "⚡ Designing highly attractive user interface for mobile and web applications",
        "⚡ Customizing logo designs and building logos from scratch",
        "⚡ Creating the flow of application functionalities to optimize user experience",
      ],
      softwareSkills: [

        {
          skillName: "Adobe Illustrator",
          fontAwesomeClassname: "simple-icons:adobeillustrator",
          style: {
            color: "#FF7C00",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/u/chaitanya11203/",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Georgetown University",
      subtitle: "B.S. Computer Science",
      logo_path: "Gtown.jpg",
      alt_name: "Georgetown University",
      duration: "2024-2026",
      descriptions: [
        "⚡ I am a junior at Georgetown University studying computer science at the college.",
        "⚡ Awarded the deans list in my first semester. Involved in acapella and hoyalytics, Georgetown's premier data analytics club",
      ],
      website_link: "https://www.georgetown.edu/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Machine Learning",
      subtitle: " - Camp K-12",
      logo_path: "campk12.png",
      certificate_link:
        "",
      alt_name: "Camp K-12",
      color_code: "#8C151599",
    },
    {
      title: "The Data Science Course",
      subtitle: "- Udemy",
      logo_path: "udemy.jpg",
      certificate_link:
        "https://www.udemy.com/certificate/UC-c3ff0490-22e5-4df5-8fa8-720adf58ec01/",
      alt_name: "Udemy",
      color_code: "#4285F499",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "",
  description:
    "I have worked extensively in large MNCs as well as emerging startups and research labs.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Founder",
          company: "Match Mind",
          company_url: "https://chaitanya11203.wixsite.com/match-mind",
          logo_path: "Matchmind.png",
          duration: "Nov 2022 - present",
          location: "New Delhi/Washington D.C.",
          description: "Using data analytics to bolster grassroots soccer",
          color: "#fc1f20",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Research Assistant",
          company: "CyberSmart Lab at Georgetown University",
          company_url: "https://cybersmartcenter.org/",
          logo_path: "cyber.png",
          duration: "May 2024 - Present",
          location: "Washington, D.C.",
          description:
            "Developing an expert model to verify ICT systems generated by LLMs, aiming to improve system reliability by 80% and reduce verification time by 40%.",
          color: "#000000",
        },
        {
          title: "Sports Analyst",
          company: "India on Track",
          company_url: "https://indiaontrack.in/",
          logo_path: "Iot.png",
          duration: "Aug 2023 - Sep 2023",
          location: "Gurgaon, Haryana",
          description:
            "Managed Apollo Tyres and Manchester United accounts, driving a 15% increase in brand engagement and a 10% growth in sponsorship revenue.",
          color: "#ee3c26",
        },
        {
          title: "Research Assistant",
          company: "Centre for Analysis of Network Data and Insight Derivation at Ashoka University",
          company_url:
            "https://www.ashoka.edu.in/page/centre-for-data-science-and-analytics/",
          logo_path: "ashoka.png",
          duration: "Jun 2022 - Jul 2023",
          location: "Sonipat, Haryana",
          description:
            "Developed an NFT price prediction model using multiple regression, achieving a 25% improvement in prediction accuracy.",
          color: "#0071C5",
        },
        {
          title: "Database Developer/ Data Analyst",
          company: "International Solar Alliance",
          company_url: "https://isolaralliance.org/",
          logo_path: "isa.png",
          duration: "Jul 2022 - Aug 2022",
          location: "Gurgaon, Haryana",
          description:
            "Served as a database developer using MongoDB to create a directory for 80 international partners, improving data accessibility and operational efficiency by 25%. Analyzed data trends for metrics like GDP, global irrigation, and per capita income, contributing to a 15% increase in forecasting accuracy.",
          color: "#0071C5",
        },
        {
          title: "Research Assistant",
          company: "Indian Institute of Technology, Delhi",
          company_url: "https://home.iitd.ac.in/",
          logo_path: "iit.png",
          duration: "Jun 2019 - Apr 2022",
          location: "New Delhi, India",
          description:
            "Worked on a LAMMPS simulator-based research project analyzing the behavior of particles under the Yukawa Potential. Utilized MATLAB and Ovito with C++ scripts to run simulations. Published a paper in an international peer-reviewed journal.",
          color: "#0071C5",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [

        {
          title: "Volunteer",
          company: "Salaam Baalak",
          company_url: "https://www.salaambaalaktrust.com/",
          logo_path: "salaam.jpg",
          duration: "Oct 2022 - Dec 2022 ",
          location: "New Delhi, India",
          description: "Taught 60+ underserved students computer science, english and mathematics.",
          color: "#181717",
        },
        {
          title: "Founder",
          company: "Dronacharya",
          company_url: "https://chaitanya11203.wixsite.com/website",
          logo_path: "dronacharya.png",
          duration: "Oct 2015 - Dec 2021 ",
          location: "New Delhi, India",
          description: "Non-profit organization initiated to provide underprivileged children access to technology. 200+ children reached, partnered with DigitialEmpowerment Foundation (DEF) and Literacy India, 2 nationally recognized aid organizations. Additionally, $1000+ was raised to fund this ventureand help the children. Boys and girls from Muslim communities were taught how to build drones and use them for farming and delivery.",
          color: "#181717",
        },
      ],
    },
  ],
};


// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools.",
  avatar_image_path: "projects_image.svg",
};
const publicationsHeader = {
  title: "Publications",
  description: "My published research.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "Yukawa Potential",
      name: "",
      createdAt: "2023-10-12T00:00:00Z",
      description: "Paper published in an international peer-reviewed journal,Chaos: An Interdisciplinary Journal of Nonlinear Science.",
      url: "https://pubs.aip.org/aip/cha/article/32/6/063136/2835966/Chaotic-dynamics-of-small-sized-charged-Yukawa",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "file.jpg",
    description:
      "Please contact me via email for any work related queries",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "Some of my thoughts and ideas about the world",
    link: "https://chaitanya11203.wixsite.com/blog",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Georgetown University",
    locality: "Georgetown",
    country: "USA",
    region: "Washington D.C.",
    postalCode: "20057",
    streetAddress: "37 O street",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://www.google.com/maps/place/Georgetown+University/@38.907613,-77.0748334,16z/data=!3m1!4b1!4m6!3m5!1s0x89b7b640ce9f8f6b:0x1c9d6d0554662882!8m2!3d38.9076089!4d-77.0722585!16zL20vMHBzcGw?entry=ttu&g_ep=EgoyMDI0MTAwMi4xIKXMDSoASAFQAw%3D%3D",
  },
  phoneSection: {
    title: "Cell Phone",
    subtitle: "202-903-9060",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
}